import i18n from '../../language/index'
import {create_title} from '@/base/titleData';
export default {
  img_effects: {
    id: 1,
    formData: {
      effect: 0,//当前选中的特效
      border: {
        radio_val: 'default',
        default: {
          borderWidth: 2,
          borderColor: "rgba(0, 0, 0, 1)",
        },
        custom: {
          borderWidth: 2,
          borderColor: "rgba(0, 0, 0, 1)",
        }
      },
      background: {
        radio_val: 'default',
        default: {
          color: "rgba(255, 255, 255, 0)",
        },
        custom: {
          color: "rgba(255, 255, 255, 1)",
        }
      },
      direction: 'left'
    }
  },

  pc_infor:{
    marginTop:'0%',
    marginLeft:'37.5%',
    marginRight:'37.5%',
    marginBottom:'0%',
    textAlign: 'center'
  },
  mb_infor:{
    marginTop:'0%',
    marginLeft:'1.733%',
    marginRight:'1.733%',
    marginBottom:'0%',
    textAlign: 'center'
  },
  pc_widgets_infor: {
    title:create_title('Search'),
    height: 54, //特殊字段，只存在搜索和按钮
    showBanner: 'true',
    bannerHeight: 50,
    showHotKey: 'true',
    showHistory: 'true',
    styleClass:'withBorder',
    styleType: 'type_0',
    borderRadius: {
      radio_val: 'default',
      default: {
        value: 0,
      },
      custom: {
        value: 0,
      }
    },
    border: {
      radio_val: 'default',
      default: {
        borderWidth: 2,
        borderLeftWidth: 0,
        borderRightWidth: 0,
        borderTopWidth: 0,
        borderBottomWidth: 0,
        borderStyle: 'solid',
        borderColor: "rgba(239,65,54,1)",
        borderSeColor: "rgba(0, 0, 0,1)",
        checkList: ['borderTopWidth', 'borderLeftWidth', 'borderRightWidth', 'borderBottomWidth'],
      },
      custom: {
        borderWidth: 0,
        borderLeftWidth: 0,
        borderRightWidth: 0,
        borderTopWidth: 0,
        borderBottomWidth: 0,
        borderStyle: 'solid',
        borderColor: "rgba(255, 255, 255,1)",
        borderSeColor: "rgba(0, 0, 0,1)",
        checkList: ['borderTopWidth', 'borderLeftWidth', 'borderRightWidth', 'borderBottomWidth'],
      }
    },

    bannerbackground: {
      radio_val: 'default',
      default: {
        type: 'color', // 背景设置-类型
        img: '', // 背景设置-图片的URL
        color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
        img_scale: 'scale_cover', //图片缩放 填充、等比例、平铺、拉伸、原图
        tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
        background_size: 'cover',
        background_repeat: 'no-repeat',
        background_position: 'center center' //图片位置
      },
      custom: {
        type: 'color', // 背景设置-类型
        img: '', // 背景设置-图片的URL
        color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
        img_scale: 'scale_cover', //图片缩放 填充、等比例、平铺、拉伸、原图
        tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
        background_size: 'cover',
        background_repeat: 'no-repeat',
        background_position: 'center center' //图片位置
      }
    }
  },
  mb_widgets_infor: {
    title:create_title('Search'),
    height: 54, //特殊字段，只存在搜索和按钮
  },
  listArr: {
    placeholder:'Please enter a keyword',
    bannerWords: 'Search',
    searchType:'blurry',//accurate 精确搜索 blurry//模糊搜索
    searchContent:'both', //both 全部参数 section 指定参数
    searchParam:[],
    keyWords: '',
    url: '',
    link: '',
    logoUrl: '',
    hot_keyWords: [],
    historyWords: []
  },
}



// WEBPACK FOOTER //
// ./src/widgets/basic_searchs/style.js